<template>
    <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    :width="queryLayer==3?'96rem':(queryLayer==2?'76rem':'56rem')"
    >
    <div slot="title" class="dialog-title">
        <p>{{ detail.softwareName+'考核情况' }}</p>
        <p class="grey">(总分</p>
        <p class="number">{{ detail.fullScore }}</p>
        <p class="grey">分   步骤总得分</p>
        <p class="number">{{ detail.totalScore ||0}}</p>
        <p class="grey">分)</p>
    </div>
    <div style="display: flex; justify-content: center;">
        <div class="content-box">
        <div class="thead">
            <div style="width: 20rem;">模块</div>
            <div style="width: 20rem;" v-if="queryLayer==1">提交时间</div>
            <div style="width: 20rem;" v-if="queryLayer>=2">考核步骤</div>
            <div style="width: 20rem;" v-if="queryLayer==2">提交时间</div>
            <div style="width: 20rem;" v-if="queryLayer==3">考核任务</div>
            <div style="width: 20rem;" v-if="queryLayer==3">提交时间</div>
            <div style="width: 10rem;">步骤得分</div>
        </div>
        <div class="tbody">
            <div v-for="(item,index) in detail.softwareScoreTree" class="tbody-item" :class="{'border-btm':index==detail.softwareScoreTree.length-1}" :key="index">
                <div  class="left-body" style="border-right:1px solid #e8ecef;width: 20rem;">
                    <el-tooltip effect="dark" :content="item.name" placement="top-start">
                        <p class="text-ovrerflow">{{ item.name }}</p>
                    </el-tooltip>
                </div>
                <p v-if="queryLayer==1" class="subtime" style="border-right:1px solid #e8ecef;width: 20rem;">{{ item.submitTime||'/' }}</p>
                <div class="children-box">
                    <div v-if="!item.children||item.children.length==0" class="child-item">
                                <p class="text-ovrerflow" style="width: 10rem;">{{ item.score==null?'/':item.score }}</p>
                            </div>
                    <div v-for="(el,i) in item.children" :class="{'border-btm':i==item.children.length-1}" style="border-bottom: 1px solid #e8ecef;" class="child-item" :key="i">
                            <div  style="border-right:1px solid #e8ecef;width: 20rem;" >
                                        <el-tooltip effect="dark" :content="el.name" placement="top-start">
                                            <p class="text-ovrerflow">{{el.name}}</p>
                                        </el-tooltip>
                            </div>
                            <p v-if="queryLayer==2" class="subtime" style="border-right:1px solid #e8ecef;width: 20rem;">{{ el.submitTime||'/' }}</p>
                        <div class="child-box">
                            <div v-for="(e,k) in el.children" :key="k" class="e-item">
                                <div  class="e-name" style="border-right:1px solid #e8ecef;width: 20rem;">
                                    <el-tooltip effect="dark" :content="e.name" placement="top-start">
                                        <p class="text-overflow">{{ e.name }}</p>
                                    </el-tooltip>
                                </div>
                                <p v-if="queryLayer==3" class="subtime" style="border-right:1px solid #e8ecef;width: 20rem;">{{ e.submitTime||'/' }}</p>
                                <p  style="width: 10rem;" class="e-score text-ovrerflow">{{ e.score }}</p>
                            </div>
                            <div v-if="!el.children||el.children.length==0" class="e-item">
                                <p class="no-score text-ovrerflow" style="width: 10rem;">{{ el.score }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    </el-dialog>
</template>

<script>
    export default {
        data(){
            return {
                dialogVisible:false,
                detail:{}
            }
        },
        methods:{
            
        },
        computed:{
            /**判断有几层结构 */
            queryLayer(){
                if(!this.detail.softwareScoreTree)return;
                let children1=this.detail.softwareScoreTree[0].children;
                if(!children1||children1.length==0){
                    return 1;
                }else{
                    let children2=children1[0].children;
                    if(!children2||children2.length==0){
                        return 2;
                    }
                }
                return 3;
            }
        },
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__title{
    font-size: 16px;
    font-weight: 700;
}
.thead{
    height: 4.8rem;
    background-color: #ECF3FF;
    display: flex;
    align-items: center;
    color: #334681;
    font-weight: 700;
    border: 1px solid #e8ecef;
    &> :nth-child(n){
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
.tbody{
    margin-bottom: 2px;
    border: 1px solid #e8ecef;
}
.tbody-item{
    display: flex;
    color: #334681;
}
.single{
    background-color: rgba(236,243,255,0.20);
}
.twin{
    background-color: #ECF3FF;
}
/deep/.el-dialog__body{
    padding:0 3rem 5rem 3rem;
}
/deep/.el-dialog__header{
    padding: 3rem 5rem;
}
/deep/.el-dialog{
    border-radius: 16px;
}
/deep/.el-dialog__headerbtn{
    top: 1rem;
    right: 14px;
    color: #8590B3;
}
.content-box{
    display: inline-block;
}
.tbody{
    max-height: 46rem;
    overflow: auto;
}
.tbody-item{
    display: flex;
    border-bottom:1px solid  #e8ecef;
    .left-body{
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 4.7rem;
    }
}
.child-item{
    display: flex;
    &> :nth-child(1){
        min-height: 4.7rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .e-item{
        height: 4.7rem;
        display: flex;
        &> :nth-child(n){
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
/deep/.v-modal{
    z-index: 900 !important;
}
.dialog-title{
    display: flex;
    color: #334681;
    &> :nth-child(1){
        font-size: 16px;
        font-weight: 700;
    }
}
.grey{
    color: #8590B3;
    font-size: 16px;
}
.number{
    font-size: 16px;
}
.border-btm{
    border-bottom:none !important;
}
.text-ovrerflow{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 2rem;
    width: 100%;
    text-align: center;
}
.subtime{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>